import { createContext, useContext } from 'react'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'

export const ToggleSdkContext = createContext<TToggleKeyValuePair | null>(null)

export default function useToggleSdkContext() {
  return useContext(ToggleSdkContext)
}
